export const snooze = "sEXEIc";
export default {snooze};